import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_BASE_URL } from '../api/axios';

const SETTINGS_CACHE_KEY = 'pm_public_settings_v1';

function readCachedSettings() {
  try {
    const raw = sessionStorage.getItem(SETTINGS_CACHE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(readCachedSettings);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/settings/public`)
      .then(r => r.json())
      .then((data) => {
        const next = data && typeof data === 'object' ? data : {};
        setSettings(next);
        try {
          sessionStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify(next));
        } catch (_) {}
      })
      .catch(() => setSettings({}));
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
